import { render, staticRenderFns } from "./software.vue?vue&type=template&id=bde3beca&scoped=true"
import script from "./software.vue?vue&type=script&lang=js"
export * from "./software.vue?vue&type=script&lang=js"
import style0 from "./software.vue?vue&type=style&index=0&id=bde3beca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde3beca",
  null
  
)

export default component.exports